import { httpGet } from '@inner-source/cis-shared/transports';

const getIssuesByProject = async ({ projectId, state }) => httpGet('/get-issues-by-project', { projectId, state });

export default getIssuesByProject;
